import {
  PublicOfferFormDetails,
  SendPublicOfferFormPayload,
  SendPublicOfferFormResponse,
} from '@features/public-offer-form/utils/models/public-offer-form.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpError } from '@shared/utils/models/http.model';

export const PublicOfferFormActions = createActionGroup({
  source: 'Public Offer Form',
  events: {
    'Validate Offer Form': props<{ userId: number }>(),
    'Validate Offer Form Success': props<{ data: PublicOfferFormDetails }>(),
    'Validate Offer Form Failure': props<{ error: HttpError }>(),
    'Send Offer Form': props<{ payload: SendPublicOfferFormPayload }>(),
    'Send Offer Form Success': props<{ data: SendPublicOfferFormResponse }>(),
    'Send Offer Form Failure': props<{ error: HttpError }>(),
  },
});

export const PublicOfferFormResetActions = createActionGroup({
  source: 'Public Offer Form',
  events: {
    'Cancel Public Offer Form Actions': emptyProps(),
    'Cancel Public Offer Form Actions Success': emptyProps(),
    'Reset Public Offer Form': emptyProps(),
  },
});
